import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { companySchema } from "./schema";
import { fetchCompanyData } from "./read";
import { useUpdateCompany } from "../update/mutation";
import { useCreateCompany } from "../create/mutation";
import { useMemo } from "react";
import { getRequiredFields } from "components/form/utils";

export const useCompanyForm = () => {
  const form = useForm({
    resolver: zodResolver(companySchema),
    defaultValues: {
      name: "",
      website: "",
      phone: "",
      email: "",
      tax_number: "",
      address_line_1: "",
      address_line_2: "",
      city: "",
      state: "",
      zipcode: "",
      country_id: "",
    },
  });

  const requiredFields = useMemo(
    () => getRequiredFields(companySchema),
    [companySchema]
  );

  const updateCompany = useUpdateCompany();
  const createCompany = useCreateCompany();

  const handleCreate = async (context) => {
    const item = context.values;
    await createCompany.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateCompany.mutateAsync({ companyId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchCompanyData({ companyId: id });
    return response;
  };

  return {
    form,
    requiredFields,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
